export default __webpack_public_path__ + "static/media/RxDN.feeb493a.svg";